
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicare-brokers",
      function () {
        return require("private-next-pages/medicare-brokers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicare-brokers"])
      });
    }
  